import React, {Component} from 'react';
import $ from 'jquery';
import {
    AJAX,
    showPreloader,
    show_success_popup,
    hidePreloader,
    cross_form_errors,
    gTagClickEvent,
    addStepLog,
    setUrlSinglePageApp
} from "../functions";
import {Redirect} from "react-router-dom";
import {showPopupWithGoBack} from '../popups/PopupWithGoBack';
import Popup from "../popups/Popup";
import {withRouter} from "react-router";
import {gTagClickEventValue} from "../booking/frontend_script";

class SendRatePage extends Component {
    constructor(props) {
        super(props);
        this.handleSetPage = this.handleSetPage.bind(this);
        this.syncFeedback = this.syncFeedback.bind(this);
        this.onChangeInput = this.onChangeInput.bind(this);
        this.displayNext = this.displayNext.bind(this);
        this.state = {redirect: false, rating: '0', feedback: '', showPositiveMsgPopup: false};
        this.syncFeedback(true);

        setUrlSinglePageApp(this.props.history.location.pathname);
    }

    syncFeedback(inConstruct) {
        let rating = this.props.booking_state.rating ? this.props.booking_state.rating :'0';
        let feedback = this.props.booking_state.feedback;

        if (inConstruct === true) {
            this.state.rating = rating;
            this.state.feedback = feedback;
        } else
            this.setState({rating: rating, feedback: feedback});
    }

    handleSetPage(options) {
        if (options.name == 'send_rate')
            addStepLog('Send rate Page');
        this.props.handleSetPage(options);
    }

    onChangeInput(e) {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({[name]: value});
    }

    displayNext() {
        return parseInt(this.state.rating, 10) > 0
    }

    sendRate(event) {
        addStepLog('Press button goNext on Send rate Page');
        if (!this.displayNext()) {
            return false;
        }

        let fields = this.props.field_list.send_rate;
        let btn = event.target;
        let form_inputs = $(btn).closest('.form-inputs');
        let params = {
			session_key: this.props.session_key,
            global_operation: this.props.global_operation,
            rating: this.state.rating,
            feedback: this.state.feedback ? this.state.feedback : '',
			action: 'api/booking/send_rate'
		};

       /* for (let item in fields) {
            let el = form_inputs.find('[name=' + fields[item] + ']');
            if (el.length) {
                params[fields[item]] = el[0].value;
            }
        }*/

        let t = this;

        AJAX(bm_ajax_url, 'POST', params, {
            response_json: true,
            func_waiting: function () {
                showPreloader();
            },
            func_callback: function (resp) {
                hidePreloader();
                if (resp.success === 1) {
                    show_success_popup('Thank you, your feedback has been successfully sent.');

                    setTimeout(()=>{
                        if (parseInt(t.state.rating,10) > 2)
                            t.setState({showPositiveMsgPopup: true});
                        else
                            t.setState({redirect: true});
                    }, 2000);

                } else if (resp.errors && 'main' in resp.errors && Object.keys(resp.errors.main).length) {
                    showPopupWithGoBack(resp.errors.main);
                }

                cross_form_errors(resp.errors !== undefined && resp.errors.form !== undefined ? resp.errors.form : {}, fields, form_inputs);
            },
            func_error: function (resp) {
                hidePreloader();
                showPopupWithGoBack(resp.message);
            }
        });
    }

    render() {
        if(this.state.redirect){
            addStepLog('Your data saving Page');
            return <Redirect push to="/your_data_saving" />;
        }

        return (

            <div className={'value-space'}>
                <div className="row">
                    <div className="offset-2 col-8">
                        <h1 className="my-4">Thank you for choosing to Go With The Gecko. Please rate your Gecko Hire
                            experience.</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="offset-2 col-8 text-center form-inputs">
                        <div className="form-group mb-4">
                            <fieldset className="rating-feedback">
                                <input type="radio" id="star5" name="rating" value="5"
                                       checked={this.state.rating == '5'}
                                       onChange={this.onChangeInput}
                                />
                                <label htmlFor="star5" />
                                <input type="radio" id="star4" name="rating" value="4"
                                       checked={this.state.rating == '4'}
                                       onChange={this.onChangeInput}
                                />
                                <label htmlFor="star4" />
                                <input type="radio" id="star3" name="rating" value="3"
                                       checked={this.state.rating == '3'}
                                       onChange={this.onChangeInput}
                                />
                                <label htmlFor="star3" />
                                <input type="radio" id="star2" name="rating" value="2"
                                       checked={this.state.rating == '2'}
                                       onChange={this.onChangeInput}
                                />
                                <label htmlFor="star2" />
                                <input type="radio" id="star1" name="rating" value="1"
                                       checked={this.state.rating == '1'}
                                       onChange={this.onChangeInput}
                                />
                                <label htmlFor="star1" />
                            </fieldset>
                            <div id="rating_errors" />
                        </div>
                        <div className="form-group mb-4">
                            <textarea name="feedback" className="form-control" placeholder="Feedback" onChange={this.onChangeInput} defaultValue={this.state.feedback}/>
                            <div id="feedback_errors" />
                        </div>
                        {
                            this.displayNext() ? (
                                <div className="go-btn go-next mx-auto" onClick={() => this.sendRate(event)}/>
                            ) : ('')
                        }
                    </div>
                </div>

                <Popup open={this.state.showPositiveMsgPopup}
                       modal
                       lockScroll
                       closeOnDocumentClick={false}
                       className={"bm-modal"}
                >
                    <>
                        {/*<button type="button" className="close" aria-label="Close" onClick={this.handleClosePopup}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <div className="clearfix" />*/}
                        <div className="col-12 p-2 text-center">
                            <p>
                                Thank you for the review of our services, we'd be very appreciative if you could take a second to post a similar review on our Google listing.
                            </p>
                            <p>
                               <a className="button-link red" href={this.props.vehicle_data.google_business_url} onClick={(e)=>{addStepLog('Press button  Click to Post Review  on popup Send rate Page');try {gTagClickEventValue('click_to_review', {'event_category': 'click_to_post_review', 'event_label': ''});} catch (e) {navigator.sendBeacon('/wp-content/plugins/booking-form/bf_notify.php?message='+encodeURIComponent(e.message)+'&origin=app');}gTagClickEvent('click_to_post_review','')}} target="_blank">Click To Post Review</a>
                            </p>
                            <p>Thank you very much!</p>
                            <div className="row mx-3">
                                <div className="go-btn go-next mx-auto" onClick={()=>{addStepLog('Press button goNext on popup Send rate Page');this.setState({redirect: true})}} />
                            </div>
                        </div>
                    </>
                </Popup>
            </div>
        );
    }
}

const SendRatePageR = withRouter(SendRatePage);
export default SendRatePageR;